// 英文语言路由表
export default [
    {
        path: '/english/yachtTours',
        component: () => import('@/views/Tours/English/Tours.vue'),
    },
    {
        path: '/super-yacht-rental-dubai',
        component: () => import('@/views/Super_yachts/English/Super_yachts.vue'),
    },
    {
        path: '/water-sports-dubai',
        component: () => import('@/views/Water_sports/English/teach.vue'),
    },
    {
        path: '/bookOrder',
        component: () => import('@/views/Fun/English/Fun.vue'),
    },
    {
        path: '/contact',
        component: () => import('@/views/Office/English/Office.vue'),
    },
    {
        path: '/fishing-dubai',
        component: () => import('@/views/Fishing/English/Fishing.vue'),
    },
    {
        path: '/team',
        component: () => import('@/views/Company/English/Company.vue'),
    },
]
